<template>
    <div>
    <!-- <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore">
      This user has been deleted.
    </trashed-message> -->
        <el-card>
            <div slot="header" class="clearfix">
                <h1 class="font-bold text-3xl">
                    <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('aspirantes')">Aspirantes</inertia-link>
                    <span class="text-indigo-400 font-medium">/</span>
                    {{ form.nombre }} {{ form.apellido }}
                </h1>
                <!-- <img v-if="user.photo" class="block w-8 h-8 rounded-full ml-4" :src="user.photo" /> -->
            </div>
            <el-form @submit.prevent="update" v-model="form" label-position="top">
                <el-collapse class="mb-3 "  v-model="activeNames">
                    <el-collapse-item name="1">
                        <template slot="title" >
                            <i class="el-icon-user"></i><p style="color:#7F5A74">Datos Personales</p>
                        </template>
                        <el-row :gutter="20">
                            <el-col :span="11">
                                <el-form-item label="Nombre:" :error="form.errors.nombre"><el-input id="nombre" v-model="form.nombre" ></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Apellido:" :error="form.errors.apellido"><el-input id="apellido" v-model="form.apellido" ></el-input></el-form-item>
                            </el-col><el-col :span="11">
                                <el-form-item label="Tipo Documento:" :error="form.errors.tipo_documento_id">
                                    <el-select v-model="form.tipo_documento_id" placeholder="Select">
                                        <el-option
                                        v-for="item in lista_documento"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Numero documento:" :error="form.errors.numero_documento"><el-input id="numero_documento" v-model="form.numero_documento" ></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Email:" :error="form.errors.correo_electronico"><el-input v-model="form.correo_electronico" ></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Fecha Nacimiento:" :error="form.errors.fecha_de_nacimiento"><el-date-picker v-model="form.fecha_de_nacimiento" type="date"></el-date-picker></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Certificado de discapacidad:" :error="form.errors.certificado_de_discapacidad">
                                     <el-select v-model="form.certificado_de_discapacidad" placeholder="Select">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Tipo discapacidad:" :error="form.errors.tipodiscapacidad"><el-input v-model="form.tipodiscapacidad"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Adaptaciones o necesidades requeridas:" :error="form.errors.adaptaciones_o_necesidades_requeridas"><el-input v-model="form.adaptaciones_o_necesidades_requeridas" ></el-input></el-form-item>
                            </el-col>
                            <!-- <el-col :span="11">
                                <el-form-item label="Contraseña:" :error="form.errors.password"><el-input v-model="form.password" type="password"></el-input></el-form-item>
                            </el-col> -->
                            <el-col :span="11">
                                <el-form-item label="Administrador?:" :error="form.errors.owner">
                                    <el-select v-model="form.owner" placeholder="Select">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Foto:" :error="form.errors.photo">
                                    <!-- <el-upload
                                    class="upload-demo"
                                    :auto-upload="false"
                                    >
                                        <el-button size="small" type="primary">Clic para subir archivo</el-button>
                                        <div slot="tip" class="el-upload__tip">Solo archivos jpg/png con un tamaño menor de 500kb</div>
                                    </el-upload> -->
                                </el-form-item>
                            </el-col>
                             
                        </el-row>
                    </el-collapse-item>
                    <el-collapse-item name="2">
                        <template slot="title">
                            <i class="el-icon-house"></i><p style="color:#7F5A74">Domicilio</p>
                        </template>
                        <el-row :gutter="20">
                            <el-col :span="11">
                                <el-form-item label="Calle:"><el-input v-model="form.domicilioConstituido_calle"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Numero:" ><el-input v-model="form.domicilioConstituido_numero"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Piso:"><el-input v-model="form.domicilioConstituido_piso"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Depto.:" ><el-input v-model="form.domicilioConstituido_departamento"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Codigo Postal:" ><el-input v-model="form.domicilioConstituido_codigo_postal"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Localidad:" ><el-input v-model="form.domicilioConstituido_localidad"></el-input></el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="Telefono:" ><el-input v-model="form.domicilioConstituido_telefono"></el-input></el-form-item>
                            </el-col>
                            
                            
                        </el-row>
                    </el-collapse-item>
                    <el-collapse-item name="3">
                        <template slot="title">
                            <i class="el-icon-suitcase-1"></i><p style="color:#7F5A74">Experiencia Judicial</p>
                        </template>
                        <el-row :gutter="20">
                            <el-col>
                                <el-form-item label="Experiencia Judicial?:" :error="form.errors.experiencia_judicial">
                                    <el-select v-model="form.experiencia_judicial" placeholder="Select">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <span>Cuentenos cual es su experiencia en el ambito judicial</span>
                                <VueEditor  v-model="form.detalle_exp_judicial"/>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                    <el-collapse-item name="4">
                        <template slot="title">
                            <i class="el-icon-reading"></i><p style="color:#7F5A74">Estudios</p>
                        </template>
                        <el-row :gutter="20">
                            <el-col :span="11">
                                <el-form-item label="Estudio">
                                    <!-- aca hay que poner un select con los estudios, averiguar como es en inertia -->
                                    <!-- <el-input v-model="form.estudio_id"></el-input> -->
                                    <el-select v-model="form.estudio_id" placeholder="Select">
                                        <el-option
                                        v-for="item in lista_estudios"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <span>Carrera</span>
                                <VueEditor v-model="form.carrera"/>
                            </el-col>
                            <el-col>
                                <span >Que otro estudio posee </span>
                                <VueEditor v-model="form.tipoestudio"/>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                    <el-collapse-item name="5">
                        <template slot="title">
                            <i class="el-icon-picture-outline-round"></i><p style="color:#7F5A74">Intereses</p>
                        </template>
                        <el-row :gutter="20">
                            <el-col>
                                <VueEditor v-model="form.intereses"/>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                </el-collapse>
                
                <el-form-item>
                    <!-- <button v-if="!user.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete User</button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update User</loading-button> -->
                    <el-button type="primary" @click="update" plain :loading="form.processing">Editar usuario</el-button>
                    <!-- <el-button v-if="!user.deleted_at" type="warning" plain :loading="form.processing">Eliminar usuario</el-button> -->
                </el-form-item>
            </el-form>
        </el-card>
      
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    errors: Object,
  },
  remember: 'form',
  data() {
    return {
        form: this.$inertia.form({
            nombre: this.aspirante.nombre,
            apellido: this.aspirante.apellido,
            tipo_documento_id: this.aspirante.tipo_documento_id,
            numero_documento: this.aspirante.numero_documento,
            correo_electronico: this.aspirante.correo_electronico,
            fecha_de_nacimiento: this.aspirante.fecha_de_nacimiento,
            certificado_de_discapacidad: this.aspirante.certificado_de_discapacidad,
            tipodiscapacidad: this.aspirante.tipodiscapacidad,
            adaptaciones_o_necesidades_requeridas: this.aspirante.adaptaciones_o_necesidades_requeridas,
            
            domicilioConstituido_calle : this.aspirante.domicilioConstituido_calle,
            domicilioConstituido_numero : this.aspirante.domicilioConstituido_numero,
            domicilioConstituido_piso : this.aspirante.domicilioConstituido_piso,
            domicilioConstituido_departamento : this.aspirante.domicilioConstituido_departamento,
            domicilioConstituido_codigo_postal : this.aspirante.domicilioConstituido_codigo_postal,
            domicilioConstituido_localidad : this.aspirante.domicilioConstituido_localidad,
            domicilioConstituido_telefono : this.aspirante.domicilioConstituido_telefono,
        
            experiencia_judicial : this.aspirante.experiencia_judicial,
            detalle_exp_judicial : this.aspirante.detalle_exp_judicial,

            estudio_id : this.aspirante.estudio_id,
            carrera : this.aspirante.carrera,
            tipoestudio : this.aspirante.tipoestudio,

            intereses : this.aspirante.intereses,
        }),
        activeNames: ['1'],
        options: [{
            value: 'true',
            label: 'SI'
        }, {
            value: 'false',
            label: 'NO'
        }],
        lista_estudios: [{
            value: '2',
            label: 'ABOGACIA'
        },
        {
            value: '3',
            label: 'MARTILLERO PUBLICO'
        }],
        lista_documento: [{
            value: '1',
            label: 'DNI'
        },
        {
            value: '2',
            label: 'PASAPORTE'
        }],
    }
  },
  watch:{
       
  },
  methods: {
    update() {
      this.form.post(this.route('users.update', this.user.id), {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(this.route('users.destroy', this.user.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(this.route('users.restore', this.user.id))
      }
    },
  },
}
</script>
